module.exports = __webpack_public_path__ + "img/mgh-nagoya-sp@2x.46abdf15.jpg";